/* 
 *  Created by SGiri 02/28/2018
 */

import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Dashboard } from '~config/model/dashbord';
import { DashboardService } from '~config/services/dashboard.service';
import { Constants } from '~util/app.constant';

@Component({
  selector: 'app-mapping-dialog',
  templateUrl: './mapping-dialog.component.html',
  styleUrls: ['./mapping-dialog.component.css']
})
export class MappingDialogComponent implements OnInit {

  mapping: any;
  header: any;
  locations: string[];
  globalDashboards: Dashboard[];
  form: FormGroup;
  id: number;
  isKpi: boolean;
  message: string;

  constructor(public dialogRef: MatDialogRef<MappingDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private service: DashboardService) {
    this.locations = Constants.locations;
    this.globalDashboards = service.globalDashboards;
    this.message = 'Loading...';
  }

  ngOnInit() {
    if (this.data.kpiId) {
      this.header = 'KPI Location Mapping';
      this.id = this.data.kpiId;
      this.isKpi = true;

    } else {
      this.header = 'Report Location Mapping';
      this.id = this.data.reportId;
      this.isKpi = false;
    }

    this.service.getLocationMapping(this.id, this.data.dashboardId, this.isKpi).subscribe(data => {
      try {
        this.mapping = data;
        this.form = new FormGroup({
          dashboardId: new FormControl(this.mapping.dashboardId),
          location: new FormControl(this.mapping.location),
          sort: new FormControl(this.mapping.sort, Validators.required),
          userId: new FormControl('*'),
          releaseVersion: new FormControl(this.mapping.releaseVersion, Validators.required)
        });
      } catch (error) {
        this.message = (this.isKpi ? 'KPI' : 'Report') + ' moved to different dashboard!';
      }
    });
  }

  save() {
    this.form.value.userId = '*';
    if (this.isKpi) {
      this.form.value.kpiId = this.id;
      this.form.value.kpiLocationId = this.mapping.kpiLocationId;
      this.service.saveKpiLocationMapping(this.form.value).subscribe();
    } else {
      this.form.value.reportId = this.id;
      this.form.value.locationId = this.mapping.locationId;
      this.service.saveReportLocationMapping(this.form.value).subscribe();
    }
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/mapping-dialog/mapping-dialog.component.ts